/*
 * Public API Surface of process-node
 */

import {AiOpenaiHook} from './lib/hook/ai/ai.openai.hook';
import {AwsCloudfrontHook} from './lib/hook/aws/aws.cloudfront.hook';
import {AwsKinesisHook} from './lib/hook/aws/aws.kinesis.hook';
import {AwsRekognitionHook} from './lib/hook/aws/aws.rekognition.hook';
import {AwsS3Hook} from './lib/hook/aws/aws.s3.hook';
import {AwsSnsHook} from './lib/hook/aws/aws.sns.hook';
import {AwsSqsHook} from './lib/hook/aws/aws.sqs.hook';
import {BankHook} from './lib/hook/bank/bank.hook';
import {CacheHook} from './lib/hook/cache/cache.hook';
import {CameraHook} from './lib/hook/camera/camera.hook';
import {ColorHook} from './lib/hook/color/color.hook';
import {ConditionHook} from './lib/hook/condition/condition.hook';
import {ContextHook} from './lib/hook/context/context.hook';
import {AssignHook} from './lib/hook/data/assign.hook';
import {DataNormalizeHook} from './lib/hook/data/data.normalize.hook';
import {VariableHook} from './lib/hook/data/variable.hook';
import {DatabaseCassandraHook} from './lib/hook/database/cassandra/database.cassandra.hook';
import {DatabaseHook} from './lib/hook/database/database.hook';
import {DatabaseMongoHook} from './lib/hook/database/mongo/database.mongo.hook';
import {DatabaseOracleHook} from './lib/hook/database/oracle/database.oracle.hook';
import {DateHook} from './lib/hook/date/date.hook';
import {DummyHook} from './lib/hook/dummy/dummy.hook';
import {EntityHook} from './lib/hook/entity/entity.hook';
import {EventIntervalHook} from './lib/hook/event/event.interval.hook';
import {FlowHook} from './lib/hook/flow/flow.hook';
import {HttpHook} from './lib/hook/http/http.hook';
import {JSDomHook} from './lib/hook/jsdom/jsdom.hook';
import {MailHook} from './lib/hook/mail/mail.hook';
import {MathHook} from './lib/hook/math/math.hook';
import {PayFiscalHook} from './lib/hook/pay/pay.fiscal.hook';
import {PayHook} from './lib/hook/pay/pay.hook';
import {PdfHook} from './lib/hook/pdf/pdf.hook';
import {PersonHook} from './lib/hook/person/person.hook';
import {ReportHook} from './lib/hook/report/report.hook';
import {RequestHook} from './lib/hook/request/request.hook';
import {SheetHook} from './lib/hook/sheet/sheet.hook';
import {SoapHook} from './lib/hook/soap/soap.hook';
import {SocketHook} from './lib/hook/socket/socket.hook';
import {SystemHook} from './lib/hook/system/system.hook';
import {TextHook} from './lib/hook/text/text.hook';
import {UserHook} from './lib/hook/user/user.hook';
import {UUIDHook} from './lib/hook/uuid/uuid.hook';
import {NumberHook} from './lib/hook/number/number.hook';
import {CronHook} from './lib/hook/date/cron.hook';
import {GoogleHook} from './lib/hook/google/google.hook';
import {AuthHook} from './lib/hook/auth/auth.hook';
import {ErrorHook} from './lib/hook/error/error.hook';
import {ArrayHook} from './lib/hook/array/array.hook';
import {QrCodeHook} from './lib/hook/qrcode/qrcode.hook';
import {FileHook} from './lib/hook/file/file.hook';
import {
    e06b7def_ac84_44e1_b267_be760ba2a809_DateHook
} from './lib/hook/third/e06b7def-ac84-44e1-b267-be760ba2a809/date.hook';
import {GeoHook} from './lib/hook/geo/geo.hook';
import {JsonHook} from './lib/hook/json/json.hook';
import {ImageHook} from './lib/hook/image/image.hook';
import {WorkflowHook} from './lib/hook/workflow/workflow.hook';
import {XmlHook} from './lib/hook/xml/xml.hook';
import {WebhookHook} from './lib/hook/webhook/webhook.hook';
import {MindHook} from './lib/hook/mind/mind.hook';


export const HOOKS = [EntityHook, AuthHook, UUIDHook, DateHook, CronHook, AwsCloudfrontHook, RequestHook, SheetHook, PayHook, AwsSqsHook,
    GoogleHook, MailHook, ReportHook, HttpHook, PdfHook, BankHook, ConditionHook, TextHook, DummyHook, MathHook, DataNormalizeHook, CacheHook,
    AwsS3Hook, AwsSnsHook, AwsKinesisHook, AwsRekognitionHook, NumberHook, SoapHook, ErrorHook, FlowHook, ArrayHook, SocketHook, AssignHook, QrCodeHook,
    FileHook, JSDomHook, PayFiscalHook, e06b7def_ac84_44e1_b267_be760ba2a809_DateHook, GeoHook, JsonHook, ContextHook, UserHook,
    DatabaseHook, DatabaseCassandraHook, DatabaseMongoHook, DatabaseOracleHook, XmlHook, ColorHook, WebhookHook, MindHook,
    ImageHook, VariableHook, SystemHook, AiOpenaiHook, EventIntervalHook, WorkflowHook, PersonHook, CameraHook];

